import { observable, action, makeObservable } from "mobx";
import { ModelSelection } from "../models/ModelSelection";

export default class ModelPickerStore {
  constructor() {
    makeObservable(this);
  }
  @observable modelSelection: ModelSelection;
  defaultModel: ModelSelection;
  alternateModel: ModelSelection;

  setModelValues(defaultModel: ModelSelection, alternateModel: ModelSelection) {
    this.defaultModel = defaultModel;
    this.alternateModel = alternateModel;
  }

  toggleModelSelection(override?: ModelSelection) {
    if (!!override) {
      this.modelSelection = override;
    } else
      this.modelSelection = (function (prev): ModelSelection {
        switch (prev) {
          case this.defaultModel:
            return this.alternateModel;
          case this.alternateModel:
          default:
            return this.defaultModel;
        }
      })(this.modelSelection);
  }
}
